// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file common/payment.proto (package common, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file common/payment.proto.
 */
export const file_common_payment: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message common.NowPaymentsWebhookPayload
 */
export type NowPaymentsWebhookPayload = Message<"common.NowPaymentsWebhookPayload"> & {
  /**
   * @generated from field: int64 payment_id = 1;
   */
  paymentId: bigint;

  /**
   * @generated from field: string payment_status = 2;
   */
  paymentStatus: string;

  /**
   * @generated from field: string pay_address = 3;
   */
  payAddress: string;

  /**
   * @generated from field: string price_amount = 4;
   */
  priceAmount: string;

  /**
   * @generated from field: string price_currency = 5;
   */
  priceCurrency: string;

  /**
   * @generated from field: string pay_amount = 6;
   */
  payAmount: string;

  /**
   * @generated from field: string actually_paid = 7;
   */
  actuallyPaid: string;

  /**
   * @generated from field: string pay_currency = 8;
   */
  payCurrency: string;

  /**
   * @generated from field: string order_id = 9;
   */
  orderId: string;

  /**
   * @generated from field: string order_description = 10;
   */
  orderDescription: string;

  /**
   * @generated from field: string purchase_id = 11;
   */
  purchaseId: string;

  /**
   * @generated from field: string outcome_amount = 12;
   */
  outcomeAmount: string;

  /**
   * @generated from field: string outcome_currency = 13;
   */
  outcomeCurrency: string;
};

/**
 * Describes the message common.NowPaymentsWebhookPayload.
 * Use `create(NowPaymentsWebhookPayloadSchema)` to create a new message.
 */
export const NowPaymentsWebhookPayloadSchema: GenMessage<NowPaymentsWebhookPayload> = /*@__PURE__*/
  messageDesc(file_common_payment, 0);

/**
 * @generated from message common.LavaTopWebhookPayload
 */
export type LavaTopWebhookPayload = Message<"common.LavaTopWebhookPayload"> & {
  /**
   * @generated from field: string event_type = 1;
   */
  eventType: string;

  /**
   * @generated from field: string contract_id = 2;
   */
  contractId: string;

  /**
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * @generated from field: string amount = 4;
   */
  amount: string;

  /**
   * @generated from field: string currency = 5;
   */
  currency: string;

  /**
   * @generated from field: string buyer_email = 6;
   */
  buyerEmail: string;

  /**
   * @generated from field: int64 timestamp = 7;
   */
  timestamp: bigint;
};

/**
 * Describes the message common.LavaTopWebhookPayload.
 * Use `create(LavaTopWebhookPayloadSchema)` to create a new message.
 */
export const LavaTopWebhookPayloadSchema: GenMessage<LavaTopWebhookPayload> = /*@__PURE__*/
  messageDesc(file_common_payment, 1);

/**
 * @generated from message common.InvoiceResult
 */
export type InvoiceResult = Message<"common.InvoiceResult"> & {
  /**
   * @generated from field: string payment_url = 1;
   */
  paymentUrl: string;

  /**
   * @generated from field: string external_id = 2;
   */
  externalId: string;
};

/**
 * Describes the message common.InvoiceResult.
 * Use `create(InvoiceResultSchema)` to create a new message.
 */
export const InvoiceResultSchema: GenMessage<InvoiceResult> = /*@__PURE__*/
  messageDesc(file_common_payment, 2);

/**
 * @generated from message common.PaymentMethodMessage
 */
export type PaymentMethodMessage = Message<"common.PaymentMethodMessage"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * @generated from field: common.PaymentDirection direction = 4;
   */
  direction: PaymentDirection;

  /**
   * @generated from field: common.PaymentProvider provider = 5;
   */
  provider: PaymentProvider;

  /**
   * @generated from field: common.CurrencyType type = 6;
   */
  type: CurrencyType;

  /**
   * @generated from field: common.CurrencyCode currency = 7;
   */
  currency: CurrencyCode;

  /**
   * @generated from field: optional common.NetworkCode network = 8;
   */
  network?: NetworkCode;

  /**
   * @generated from field: repeated string amounts = 9;
   */
  amounts: string[];

  /**
   * @generated from field: bool is_amount_editable = 10;
   */
  isAmountEditable: boolean;

  /**
   * Per-country config as JSON string: {"ru": {"categories": ["popular"]}}
   *
   * @generated from field: optional string country_config = 11;
   */
  countryConfig?: string;

  /**
   * @generated from field: optional string min_amount = 12;
   */
  minAmount?: string;

  /**
   * @generated from field: optional string max_amount = 13;
   */
  maxAmount?: string;

  /**
   * @generated from field: optional string fee_percent = 14;
   */
  feePercent?: string;

  /**
   * @generated from field: optional string fee_fixed = 15;
   */
  feeFixed?: string;

  /**
   * @generated from field: bool is_active = 16;
   */
  isActive: boolean;

  /**
   * Categories resolved for the requested country
   *
   * @generated from field: repeated string categories = 17;
   */
  categories: string[];

  /**
   * Per-locale name translations for transaction history
   *
   * @generated from field: repeated common.PaymentMethodNameTranslation name_translations = 18;
   */
  nameTranslations: PaymentMethodNameTranslation[];

  /**
   * Custom icon stored as blob in DB; non-empty only when the admin uploaded one
   *
   * @generated from field: optional bytes icon_data = 19;
   */
  iconData?: Uint8Array;

  /**
   * @generated from field: optional string icon_mime = 20;
   */
  iconMime?: string;

  /**
   * Display order (lower = first); null means unordered (shown last)
   *
   * @generated from field: optional int32 sort_order = 21;
   */
  sortOrder?: number;

  /**
   * Per-category display order: {"popular": 0, "cards": 2}
   *
   * @generated from field: map<string, int32> category_sort_orders = 22;
   */
  categorySortOrders: { [key: string]: number };

  /**
   * Extra form fields config as JSON: [{key, enabled, placeholder, label}]
   *
   * @generated from field: optional string form_fields = 23;
   */
  formFields?: string;

  /**
   * Admin-only stats: total orders count per direction (all statuses)
   *
   * @generated from field: optional int64 deposits_count = 24;
   */
  depositsCount?: bigint;

  /**
   * @generated from field: optional int64 withdrawals_count = 25;
   */
  withdrawalsCount?: bigint;

  /**
   * Admin-only stats: sum of completed orders per direction
   *
   * @generated from field: optional string deposits_sum = 26;
   */
  depositsSum?: string;

  /**
   * @generated from field: optional string withdrawals_sum = 27;
   */
  withdrawalsSum?: string;

  /**
   * Admin-only stats: conversion rate = completed / total * 100 (as string percentage)
   *
   * @generated from field: optional string deposits_conversion = 28;
   */
  depositsConversion?: string;

  /**
   * @generated from field: optional string withdrawals_conversion = 29;
   */
  withdrawalsConversion?: string;
};

/**
 * Describes the message common.PaymentMethodMessage.
 * Use `create(PaymentMethodMessageSchema)` to create a new message.
 */
export const PaymentMethodMessageSchema: GenMessage<PaymentMethodMessage> = /*@__PURE__*/
  messageDesc(file_common_payment, 3);

/**
 * @generated from message common.PaymentCategoryConfigMessage
 */
export type PaymentCategoryConfigMessage = Message<"common.PaymentCategoryConfigMessage"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: int32 sort_order = 2;
   */
  sortOrder: number;
};

/**
 * Describes the message common.PaymentCategoryConfigMessage.
 * Use `create(PaymentCategoryConfigMessageSchema)` to create a new message.
 */
export const PaymentCategoryConfigMessageSchema: GenMessage<PaymentCategoryConfigMessage> = /*@__PURE__*/
  messageDesc(file_common_payment, 4);

/**
 * @generated from message common.PaymentMethodNameTranslation
 */
export type PaymentMethodNameTranslation = Message<"common.PaymentMethodNameTranslation"> & {
  /**
   * @generated from field: string locale = 1;
   */
  locale: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message common.PaymentMethodNameTranslation.
 * Use `create(PaymentMethodNameTranslationSchema)` to create a new message.
 */
export const PaymentMethodNameTranslationSchema: GenMessage<PaymentMethodNameTranslation> = /*@__PURE__*/
  messageDesc(file_common_payment, 5);

/**
 * @generated from message common.PaymentProviderConfigMessage
 */
export type PaymentProviderConfigMessage = Message<"common.PaymentProviderConfigMessage"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: common.PaymentProvider provider = 2;
   */
  provider: PaymentProvider;

  /**
   * @generated from field: bool is_enabled = 3;
   */
  isEnabled: boolean;

  /**
   * JSON string
   *
   * @generated from field: string config = 4;
   */
  config: string;

  /**
   * @generated from field: string created_at = 5;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 6;
   */
  updatedAt: string;
};

/**
 * Describes the message common.PaymentProviderConfigMessage.
 * Use `create(PaymentProviderConfigMessageSchema)` to create a new message.
 */
export const PaymentProviderConfigMessageSchema: GenMessage<PaymentProviderConfigMessage> = /*@__PURE__*/
  messageDesc(file_common_payment, 6);

/**
 * @generated from message common.PaymentProviderOfferMessage
 */
export type PaymentProviderOfferMessage = Message<"common.PaymentProviderOfferMessage"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: common.PaymentProvider provider = 2;
   */
  provider: PaymentProvider;

  /**
   * @generated from field: common.CurrencyCode currency = 3;
   */
  currency: CurrencyCode;

  /**
   * @generated from field: string amount = 4;
   */
  amount: string;

  /**
   * @generated from field: string display_amount = 5;
   */
  displayAmount: string;

  /**
   * @generated from field: string external_id = 6;
   */
  externalId: string;

  /**
   * @generated from field: optional string meta = 7;
   */
  meta?: string;

  /**
   * @generated from field: bool is_active = 8;
   */
  isActive: boolean;

  /**
   * @generated from field: string created_at = 9;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 10;
   */
  updatedAt: string;
};

/**
 * Describes the message common.PaymentProviderOfferMessage.
 * Use `create(PaymentProviderOfferMessageSchema)` to create a new message.
 */
export const PaymentProviderOfferMessageSchema: GenMessage<PaymentProviderOfferMessage> = /*@__PURE__*/
  messageDesc(file_common_payment, 7);

/**
 * @generated from enum common.PaymentProvider
 */
export enum PaymentProvider {
  /**
   * @generated from enum value: PAYMENT_PROVIDER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PAYMENT_PROVIDER_LEGACY = 1;
   */
  LEGACY = 1,

  /**
   * @generated from enum value: PAYMENT_PROVIDER_CRONIKA = 2;
   */
  CRONIKA = 2,

  /**
   * @generated from enum value: PAYMENT_PROVIDER_NOWPAYMENTS = 3;
   */
  NOWPAYMENTS = 3,

  /**
   * @generated from enum value: PAYMENT_PROVIDER_LAVATOP = 4;
   */
  LAVATOP = 4,

  /**
   * @generated from enum value: PAYMENT_PROVIDER_P2P = 5;
   */
  P2P = 5,

  /**
   * @generated from enum value: PAYMENT_PROVIDER_VOLET = 6;
   */
  VOLET = 6,

  /**
   * @generated from enum value: PAYMENT_PROVIDER_PAYPORT = 7;
   */
  PAYPORT = 7,

  /**
   * @generated from enum value: PAYMENT_PROVIDER_BITNBOX = 8;
   */
  BITNBOX = 8,

  /**
   * @generated from enum value: PAYMENT_PROVIDER_MONEYGO = 9;
   */
  MONEYGO = 9,

  /**
   * @generated from enum value: PAYMENT_PROVIDER_COINCE = 10;
   */
  COINCE = 10,

  /**
   * @generated from enum value: PAYMENT_PROVIDER_IFIN = 11;
   */
  IFIN = 11,
}

/**
 * Describes the enum common.PaymentProvider.
 */
export const PaymentProviderSchema: GenEnum<PaymentProvider> = /*@__PURE__*/
  enumDesc(file_common_payment, 0);

/**
 * @generated from enum common.PaymentDirection
 */
export enum PaymentDirection {
  /**
   * @generated from enum value: PAYMENT_DIRECTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PAYMENT_DIRECTION_DEPOSIT = 1;
   */
  DEPOSIT = 1,

  /**
   * @generated from enum value: PAYMENT_DIRECTION_WITHDRAWAL = 2;
   */
  WITHDRAWAL = 2,
}

/**
 * Describes the enum common.PaymentDirection.
 */
export const PaymentDirectionSchema: GenEnum<PaymentDirection> = /*@__PURE__*/
  enumDesc(file_common_payment, 1);

/**
 * @generated from enum common.CurrencyType
 */
export enum CurrencyType {
  /**
   * @generated from enum value: CURRENCY_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CURRENCY_TYPE_FIAT = 1;
   */
  FIAT = 1,

  /**
   * @generated from enum value: CURRENCY_TYPE_CRYPTO = 2;
   */
  CRYPTO = 2,
}

/**
 * Describes the enum common.CurrencyType.
 */
export const CurrencyTypeSchema: GenEnum<CurrencyType> = /*@__PURE__*/
  enumDesc(file_common_payment, 2);

/**
 * @generated from enum common.CurrencyCode
 */
export enum CurrencyCode {
  /**
   * @generated from enum value: CURRENCY_CODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CURRENCY_CODE_USD = 1;
   */
  USD = 1,

  /**
   * @generated from enum value: CURRENCY_CODE_RUB = 2;
   */
  RUB = 2,

  /**
   * @generated from enum value: CURRENCY_CODE_KZT = 3;
   */
  KZT = 3,

  /**
   * @generated from enum value: CURRENCY_CODE_EUR = 4;
   */
  EUR = 4,

  /**
   * @generated from enum value: CURRENCY_CODE_CNY = 5;
   */
  CNY = 5,

  /**
   * @generated from enum value: CURRENCY_CODE_JPY = 6;
   */
  JPY = 6,

  /**
   * @generated from enum value: CURRENCY_CODE_GBP = 7;
   */
  GBP = 7,

  /**
   * @generated from enum value: CURRENCY_CODE_CHF = 8;
   */
  CHF = 8,

  /**
   * @generated from enum value: CURRENCY_CODE_SGD = 9;
   */
  SGD = 9,

  /**
   * @generated from enum value: CURRENCY_CODE_HKD = 10;
   */
  HKD = 10,

  /**
   * @generated from enum value: CURRENCY_CODE_NZD = 11;
   */
  NZD = 11,

  /**
   * @generated from enum value: CURRENCY_CODE_USDT = 12;
   */
  USDT = 12,

  /**
   * @generated from enum value: CURRENCY_CODE_USDC = 13;
   */
  USDC = 13,

  /**
   * @generated from enum value: CURRENCY_CODE_BTC = 14;
   */
  BTC = 14,

  /**
   * @generated from enum value: CURRENCY_CODE_ETH = 15;
   */
  ETH = 15,

  /**
   * @generated from enum value: CURRENCY_CODE_LTC = 16;
   */
  LTC = 16,

  /**
   * @generated from enum value: CURRENCY_CODE_TRX = 17;
   */
  TRX = 17,

  /**
   * @generated from enum value: CURRENCY_CODE_BNB = 18;
   */
  BNB = 18,

  /**
   * @generated from enum value: CURRENCY_CODE_SOL = 19;
   */
  SOL = 19,

  /**
   * @generated from enum value: CURRENCY_CODE_TON = 20;
   */
  TON = 20,

  /**
   * @generated from enum value: CURRENCY_CODE_POLYGON = 21;
   */
  POLYGON = 21,

  /**
   * @generated from enum value: CURRENCY_CODE_ARS = 22;
   */
  ARS = 22,

  /**
   * @generated from enum value: CURRENCY_CODE_UZS = 23;
   */
  UZS = 23,

  /**
   * @generated from enum value: CURRENCY_CODE_CLP = 24;
   */
  CLP = 24,

  /**
   * @generated from enum value: CURRENCY_CODE_COP = 25;
   */
  COP = 25,

  /**
   * @generated from enum value: CURRENCY_CODE_VES = 26;
   */
  VES = 26,

  /**
   * African currencies (iFin geo)
   *
   * Kenyan Shilling
   *
   * @generated from enum value: CURRENCY_CODE_KES = 27;
   */
  KES = 27,

  /**
   * South African Rand
   *
   * @generated from enum value: CURRENCY_CODE_ZAR = 28;
   */
  ZAR = 28,

  /**
   * Ghanaian Cedi
   *
   * @generated from enum value: CURRENCY_CODE_GHS = 29;
   */
  GHS = 29,

  /**
   * Ugandan Shilling
   *
   * @generated from enum value: CURRENCY_CODE_UGX = 30;
   */
  UGX = 30,

  /**
   * Zambian Kwacha
   *
   * @generated from enum value: CURRENCY_CODE_ZMW = 31;
   */
  ZMW = 31,

  /**
   * Central African CFA Franc (Cameroon)
   *
   * @generated from enum value: CURRENCY_CODE_XAF = 32;
   */
  XAF = 32,

  /**
   * Rwandan Franc
   *
   * @generated from enum value: CURRENCY_CODE_RWF = 33;
   */
  RWF = 33,

  /**
   * Tanzanian Shilling
   *
   * @generated from enum value: CURRENCY_CODE_TZS = 34;
   */
  TZS = 34,

  /**
   * Egyptian Pound
   *
   * @generated from enum value: CURRENCY_CODE_EGP = 35;
   */
  EGP = 35,
}

/**
 * Describes the enum common.CurrencyCode.
 */
export const CurrencyCodeSchema: GenEnum<CurrencyCode> = /*@__PURE__*/
  enumDesc(file_common_payment, 3);

/**
 * @generated from enum common.NetworkCode
 */
export enum NetworkCode {
  /**
   * @generated from enum value: NETWORK_CODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: NETWORK_CODE_ETH = 1;
   */
  ETH = 1,

  /**
   * @generated from enum value: NETWORK_CODE_ERC20 = 2;
   */
  ERC20 = 2,

  /**
   * @generated from enum value: NETWORK_CODE_BEP20 = 3;
   */
  BEP20 = 3,

  /**
   * @generated from enum value: NETWORK_CODE_TRC20 = 4;
   */
  TRC20 = 4,

  /**
   * @generated from enum value: NETWORK_CODE_POLYGON = 5;
   */
  POLYGON = 5,

  /**
   * @generated from enum value: NETWORK_CODE_CARD = 6;
   */
  CARD = 6,

  /**
   * @generated from enum value: NETWORK_CODE_SBP = 7;
   */
  SBP = 7,

  /**
   * @generated from enum value: NETWORK_CODE_PIX = 8;
   */
  PIX = 8,

  /**
   * @generated from enum value: NETWORK_CODE_STRIPE = 9;
   */
  STRIPE = 9,

  /**
   * @generated from enum value: NETWORK_CODE_TON = 10;
   */
  TON = 10,

  /**
   * @generated from enum value: NETWORK_CODE_SOL = 11;
   */
  SOL = 11,

  /**
   * @generated from enum value: NETWORK_CODE_BTC = 12;
   */
  BTC = 12,

  /**
   * @generated from enum value: NETWORK_CODE_PAYPAL = 13;
   */
  PAYPAL = 13,

  /**
   * @generated from enum value: NETWORK_CODE_BINANCEPAY = 14;
   */
  BINANCEPAY = 14,

  /**
   * @generated from enum value: NETWORK_CODE_KUCOINPAY = 15;
   */
  KUCOINPAY = 15,

  /**
   * @generated from enum value: NETWORK_CODE_APPLE_PAY = 16;
   */
  APPLE_PAY = 16,
}

/**
 * Describes the enum common.NetworkCode.
 */
export const NetworkCodeSchema: GenEnum<NetworkCode> = /*@__PURE__*/
  enumDesc(file_common_payment, 4);

/**
 * @generated from enum common.NowPaymentsPaymentStatus
 */
export enum NowPaymentsPaymentStatus {
  /**
   * @generated from enum value: NP_STATUS_UNSPECIFIED = 0;
   */
  NP_STATUS_UNSPECIFIED = 0,

  /**
   * @generated from enum value: NP_STATUS_WAITING = 1;
   */
  NP_STATUS_WAITING = 1,

  /**
   * @generated from enum value: NP_STATUS_CONFIRMING = 2;
   */
  NP_STATUS_CONFIRMING = 2,

  /**
   * @generated from enum value: NP_STATUS_CONFIRMED = 3;
   */
  NP_STATUS_CONFIRMED = 3,

  /**
   * @generated from enum value: NP_STATUS_SENDING = 4;
   */
  NP_STATUS_SENDING = 4,

  /**
   * @generated from enum value: NP_STATUS_PARTIALLY_PAID = 5;
   */
  NP_STATUS_PARTIALLY_PAID = 5,

  /**
   * @generated from enum value: NP_STATUS_FINISHED = 6;
   */
  NP_STATUS_FINISHED = 6,

  /**
   * @generated from enum value: NP_STATUS_FAILED = 7;
   */
  NP_STATUS_FAILED = 7,

  /**
   * @generated from enum value: NP_STATUS_REFUNDED = 8;
   */
  NP_STATUS_REFUNDED = 8,

  /**
   * @generated from enum value: NP_STATUS_EXPIRED = 9;
   */
  NP_STATUS_EXPIRED = 9,
}

/**
 * Describes the enum common.NowPaymentsPaymentStatus.
 */
export const NowPaymentsPaymentStatusSchema: GenEnum<NowPaymentsPaymentStatus> = /*@__PURE__*/
  enumDesc(file_common_payment, 5);

/**
 * @generated from enum common.LavaTopWebhookStatus
 */
export enum LavaTopWebhookStatus {
  /**
   * @generated from enum value: LT_STATUS_UNSPECIFIED = 0;
   */
  LT_STATUS_UNSPECIFIED = 0,

  /**
   * @generated from enum value: LT_STATUS_COMPLETED = 1;
   */
  LT_STATUS_COMPLETED = 1,

  /**
   * @generated from enum value: LT_STATUS_FAILED = 2;
   */
  LT_STATUS_FAILED = 2,

  /**
   * @generated from enum value: LT_STATUS_PENDING = 3;
   */
  LT_STATUS_PENDING = 3,

  /**
   * @generated from enum value: LT_STATUS_CANCELLED = 4;
   */
  LT_STATUS_CANCELLED = 4,

  /**
   * @generated from enum value: LT_STATUS_EXPIRED = 5;
   */
  LT_STATUS_EXPIRED = 5,
}

/**
 * Describes the enum common.LavaTopWebhookStatus.
 */
export const LavaTopWebhookStatusSchema: GenEnum<LavaTopWebhookStatus> = /*@__PURE__*/
  enumDesc(file_common_payment, 6);

